export const formatStock = (qty: number) => (qty > 999 ? "+999" : qty);
